import type { ValidationFunction } from "core/validators";

interface ValidationSet {
  [key: string]: ValidationFunction;
}
/**
 * Validate an array of object.
 * The validateArray take a set of validation to apply to each element of the array .
 * Each key of the set must correspond to a key of an array element.
 * @param validationSet - An object which associate a key corresponding to a property name and a validation
 */
export default function validateArray(validationSet: ValidationSet) {
  return (_key, arrayToCheck) => {
    for (const arrayElement of arrayToCheck) {
      // Here we loop on each key of our validation set
      for (const propertyKey of Object.keys(validationSet)) {
        // Get the validation from the key
        const validation = validationSet[propertyKey];
        // Apply the validation and keep the result
        const result = validation(propertyKey, arrayElement[propertyKey]);
        // We only return here if we have an error. Otherwise we continue the validations.
        if (result !== true) return result;
      }
    }
    return true;
  };
}
